import { motion } from 'framer-motion';

const ServerAdminTechnologies = () => {
  const logos = [
    { name: 'Red Hat', logo: '/Logos/Red_Hat_Logo.svg' },
    { name: 'Oracle', logo: '/Logos/oci_logo.png' },
    { name: 'Ubuntu', logo: '/Logos/Ubuntu.svg' },
    { name: 'Nutanix', logo: '/Logos/Nutanix_Logo.svg' },
    { name: 'VMware', logo: '/Logos/vmware.svg' },
    { name: 'Proxmox', logo: '/Logos/Proxmox_logo.svg' },
    { name: 'XCP-ng', logo: '/Logos/XCP-ng.svg' },
    { name: 'Citrix', logo: '/Logos/Citrix_logo.svg' },
  ];

  const LogoRow = ({ logos, direction, speed = 30 }: { logos: any[], direction: 'left' | 'right', speed?: number }) => {
    const duplicatedLogos = [...logos, ...logos];
    
    return (
      <div className="overflow-hidden whitespace-nowrap">
        <motion.div
          className="flex items-center space-x-12"
          animate={{
            x: direction === 'left' ? [0, -100 * logos.length] : [-100 * logos.length, 0]
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: speed,
              ease: "linear",
            },
          }}
          style={{ width: `${200 * logos.length}%` }}
        >
          {duplicatedLogos.map((partner, index) => (
            <div
              key={`${partner.name}-${index}`}
              className={`flex-shrink-0 w-32 h-16 flex items-center justify-center group`}
            >
              <img 
                src={partner.logo} 
                alt={`${partner.name} logo`} 
                className={`${partner.name === 'VMware' ? 'max-h-36' : [ 'Ubuntu', 'Proxmox', 'XCP-ng'].includes(partner.name) ? 'max-h-20' : 'max-h-12'} max-w-full object-contain transition-all duration-300 group-hover:scale-105 group-hover:drop-shadow-lg`}
              />
            </div>
          ))}
        </motion.div>
      </div>
    );
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            Technologies We Use
            <span className="block text-[#00204a] mt-2">
              For Server Administration
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mt-6">
            We utilize a wide range of industry-leading technologies to ensure robust and reliable server administration.
          </p>
        </motion.div>

        <div className="space-y-8">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <LogoRow logos={logos} direction="left" speed={35} />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServerAdminTechnologies;